// PHA-1168 Reports: the aggregate table a report shows above its rows ("count
// of patients per clinic"). The server computes it over the whole result, not
// just the rows on screen.
import React from 'react';
import { Table, Text } from '@radix-ui/themes';
import type { ReportSummaryTable as Summary } from '../../services/api';
import { formatCell } from './format';

const fmt = (value: number | null | undefined) => formatCell(value, 'number');

const ReportSummaryTable: React.FC<{ summary: Summary }> = ({ summary }) => {
  const grouped = !!summary.group_by;
  return (
    <Table.Root size="1" variant="surface" data-testid="report-summary">
      <Table.Header>
        <Table.Row className="bg-slate-50">
          <Table.ColumnHeaderCell>{grouped ? summary.group_label || 'Group' : 'Summary'}</Table.ColumnHeaderCell>
          {summary.measures.map((m) => (
            <Table.ColumnHeaderCell key={m.key} justify="end">{m.label}</Table.ColumnHeaderCell>
          ))}
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {/* Without group_by the server sends one row that is the total itself. */}
        {summary.rows.map((row, i) => (
          <Table.Row key={`${row.group ?? 'none'}-${i}`}>
            <Table.Cell>
              <Text size="2">{grouped ? row.group ?? '(blank)' : 'Total'}</Text>
            </Table.Cell>
            {summary.measures.map((m) => (
              <Table.Cell key={m.key} justify="end"><Text size="2">{fmt(row.values[m.key])}</Text></Table.Cell>
            ))}
          </Table.Row>
        ))}
        {grouped && (
          <Table.Row style={{ background: '#f8f9fa' }}>
            <Table.Cell><Text size="2" weight="bold">Total</Text></Table.Cell>
            {summary.measures.map((m) => (
              <Table.Cell key={m.key} justify="end">
                <Text size="2" weight="bold">{fmt(summary.total[m.key])}</Text>
              </Table.Cell>
            ))}
          </Table.Row>
        )}
      </Table.Body>
    </Table.Root>
  );
};

export default ReportSummaryTable;
